<form class="au-row" [formGroup]="autocompleteFilterForm">
  <mat-form-field class="col">
    <mat-chip-grid #chipList class="w-100">
      @for (filter of selectedFilters; track filter) {
      <mat-chip-row
        color="primary"
        [selectable]="false"
        [removable]="true"
        (removed)="remove(filter)"
      >
        {{ filter.name }} : {{ filter.viewValue }}
        <button matChipRemove>
          <mat-icon color="warn" class="fa-close"></mat-icon>
        </button>
      </mat-chip-row>
      }
      <input
        placeholder="{{ filterPlaceHolder }}"
        #filterInput
        formControlName="filter"
        [matChipInputFor]="chipList"
        [matAutocomplete]="autocomplete"
        [matChipInputAddOnBlur]="false"
      />
      <mat-autocomplete
        #autocomplete="matAutocomplete"
        autoActiveFirstOption
        (optionSelected)="selected($event)"
      >
        @for (item of filteredCategories | async; track item) {
        <mat-option [value]="item">
          {{ item | chipListDescription: activeFilter }}
        </mat-option>
        }
      </mat-autocomplete>
      <ng-content></ng-content>
    </mat-chip-grid>
  </mat-form-field>
</form>
